<template>
  <div class="md-layout">
    <div
      class="md-layout-item"
      :style="{
        paddingLeft: isMobile.isMobile ? '15px' : '',
        paddingRight: isMobile.isMobile ? '15px' : '',
      }"
    >
      <!-- 搜索栏  -->
      <md-toolbar
        color="success"
        class="header"
        :style="{
          height: isMobile.isMobile ? '44px' : '56px',
          lineHeight: isMobile.isMobile ? '44px' : '56px',
          margin: isMobile.isMobile ? '10px 0' : '0px',
          minHeight: isMobile.isMobile ? '44px' : '56px',
        }"
      >
        <span
          :style="{
            width: '80px',
            float: 'left',
            color: '#fff',
            margin: isMobile.isMobile ? '0 0px' : '0px 20px',
          }"
          >需求审批</span
        >

        <v-spacer></v-spacer>
        <div
          class="d-sm-flex justify-between"
          :style="{
            float: isMobile.isMobile ? '' : 'right',
            marginRight: isMobile.isMobile ? '' : '20px',
          }"
        >
          <div>
            <div style="display: inline-block" @mousedown="mouseDown" v-if="!isMobile.isMobile">
              <el-cascader
                size="small"
                placeholder="全部"
                @change="onchange"
                v-model="optionsValue"
                :props="cascaderProps"
                id="coursefilterWrap"
                ref="coursefilterWrap"
                :show-all-levels="true"
              >
                <template slot-scope="{ node, data }">
                  <span style="display: block" @click="onClick(node)">{{ data.name }}</span>
                </template>
              </el-cascader>
            </div>
            <md-button
              v-if="isMobile.isMobile"
              class="md-toolbar-toggle md-just-icon md-round md-simple md-toolbar-section-end"
              :class="{ toggled: $sidebar.showSidebar }"
              style="float: right; color: #fff !important; margin-right: 0px"
              @click.stop="toggleSidebar"
            >
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </md-button>
          </div>
        </div>
      </md-toolbar>

      <v-card>
        <v-card-text class="px-0 py-0 textWrap">
          <v-progress-circular
            v-if="loading"
            indeterminate
            style="position: absolute; left: 0; right: 0; top: 18px; bottom: 0; margin: auto"
            color="rgb(76, 175, 80)"
          ></v-progress-circular>
          <v-data-table
            :headers="headers"
            :items="list"
            loading-text="加载中..."
            no-data-text="暂无数据"
            :page.sync="pagination.page"
            hide-default-footer
            :items-per-page="pagination.itemsPerPage"
            mobile-breakpoint="0"
            class="paginated-table table-striped table-hover"
          >
            >
            <template #top>
              <v-toolbar flat height="80">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="请输入名称"
                  single-line
                  hide-details
                  @keydown="keydownSearch"
                  class="valueFilter"
                ></v-text-field>
                <md-tooltip md-direction="top">按回车以检索</md-tooltip>
                <!-- <v-spacer></v-spacer>
                <v-btn
                  height="35"
                  :ripple="false"
                  small
                  elevation="0"
                  class="font-weight-normal text-capitalize btn-primary bg-gradient-success py-3 px-6 ms-3"
                  >新增</v-btn
                > -->
              </v-toolbar>
            </template>

            <template #[`item.label`]="{ item }">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <a v-bind="attrs" v-on="on">
                    {{ item.label }}
                  </a>
                </template>
                <span>
                  <img
                    :src="
                      item.requirement_imagevideo_list.length > 0
                        ? item.requirement_imagevideo_list[0].url
                        : ''
                    "
                    style="display: block; width: 80px; height: 60px"
                    alt=""
                  />
                </span>
              </v-tooltip>
            </template>
            <template #[`item.updated_at`]="{ item }">
              <span>{{ dateFormat(item.updated_at) }}</span>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn
                elevation="0"
                :ripple="false"
                height="28"
                width="36"
                class="btn-ls me-2 my-2 rounded-sm"
                color="rgb(159,159,159)"
                plain
                small
                @click="openAudit(item)"
              >
                {{ product(item) }}
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <!-- 分页 -->
        <Pagination
          :page.sync="pagination.page"
          :total="pagination.total"
          :items-per-page.sync="pagination.itemsPerPage"
          @refresh="refreshResourceList"
        />
        <!-- <DevNew
          v-if="showNewDialog"
          :showNewDialog="showNewDialog"
          :formData="auditNewData"
          :metaListData="queryParams[0].listData"
          @handleAgree="handleAgree"
          @handleReject="handleReject"
          @handleCancel="handleCancel"
        /> -->
        <viewDialog
          :isView="isView"
          ref="view"
          @closeViewDialog="closeViewDialog"
          :viewDialogVisible="viewDialogVisible"
          v-if="viewDialogVisible"
          :viewDialogData="viewDialogData"
        ></viewDialog>
      </v-card>
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination/index';
// import { headers } from './Setting/Header';
import Fuse from 'fuse.js';
import Swal from 'sweetalert2';
import moment from 'moment';
import DevNew from './Action/DevNew';
import { updateNewModelResource, list_model_resourceNew } from '@/api/model_resource';
import viewDialog from '../../../DesignPage/Main/Action/modelResources/view.vue';
import { categoryList } from '../../../../api/user';
import { mapGetters } from 'vuex';
export default {
  name: 'AuditMod',
  components: {
    DevNew,
    Pagination,
    viewDialog,
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  data() {
    return {
      optionsValue: ['all'],
      tooltipValue: '全部',
      cascaderProps: {
        label: 'name',
        value: 'code',
        lazy: true,
        lazyLoad: (node, resolve) => {
          let that = this;
          const { level } = node;
          setTimeout(() => {
            if (node.level == 0) {
              let options = [
                {
                  code: 'all',
                  name: '全部',
                  level: 0,
                  leaf: true,
                  children: [],
                },
                // { code: 'bjrs', name: '毕节人社', level: 0,  leaf:false, },
                { code: 'bk', name: '本科', level: 0, leaf: false },
                { code: 'gz', name: '高职', level: 0, leaf: false },
                { code: 'zz', name: '中职', level: 0, leaf: false },
                { code: 'gj', name: '技师学院', level: 0, leaf: false },
                { code: 'jx', name: '技校', level: 0, leaf: false },
                { code: 'qy', name: '企业', level: 0, leaf: false },
              ];

              resolve(options);
            }
            if (node.level == 1) {
              if (node.value == '') {
                return;
              }
              let params = {
                cate_type: node.value || '',
                level: '1',
                parentCode: '',
              };
              categoryList(params).then(res => {
                if (res.data) {
                  res.data &&
                    res.data.forEach(item => {
                      item.leaf = false;
                    });
                  if (params.cate_type !== 'all') {
                    res.data.unshift({
                      cate_type: 'all',
                      code: 'all',
                      name: '全部',
                      _id: '123456',
                      children: [],
                      leaf: true,
                      level: 1,
                    });
                  }
                  resolve(res.data);
                }
              });
            }
            if (node.level == 2) {
              let params = {
                cate_type: node.parent.value || '',
                level: '2',
                parentCode: node.value || '',
              };
              categoryList(params).then(res => {
                if (res.data) {
                  res.data.forEach(item => {
                    item.leaf = true;
                  });
                  if (params.parentCode !== 'all') {
                    res.data.unshift({
                      cate_type: 'all',
                      code: 'all',
                      name: '全部',
                      _id: '111111111111111',
                      children: [],
                      leaf: true,
                      level: 2,
                    });
                  }

                  resolve(res.data);
                }
              });
            } else if (node.level > 2) {
              resolve([]);
            }
          }, 100);
        },
      },
      loading: false,
      viewDialogData: {},
      isView: '需求审批',
      viewDialogVisible: false,
      headers: [
        {
          text: '名 称',
          value: 'label',
          align: 'center',
          sortable: false,
          class: 'text-secondary font-weight-bolder opacity-7',
        },

        {
          text: '申请日期',
          value: 'updated_at',
          sortable: false,
          align: 'center',

          class: 'text-secondary font-weight-bolder opacity-7',
        },
        {
          text: '操作人员',
          value: 'nickName',
          align: 'center',
          sortable: false,
        },

        {
          text: '操作',
          value: 'actions',
          align: 'center',
          sortable: false,
          class: 'text-secondary font-weight-bolder opacity-7',
        },
      ],
      // 搜索条件
      search: '',
      // 遮罩层
      // loading: true,
      // 表格数据
      list: [],

      // 分页
      pagination: {
        page: 1,
        itemsPerPage: 10,
        total: 0,
      },
      // 是否显示弹出框
      showNewDialog: false,
      // 元件类型字典
      metaDict: {
        scene: '场景',
        role: '角色',
        tool: '工具',
        device: '设备',
      },
      // 状态
      statusListData: [],
      // 状态字典
      statusDict: {},
      // 审核数据
      auditNewData: {},
      // 当前选中数据
      currentItem: {},

      //头部查询字段数据
      majorGroup: '',
      majorGroup2: '',
      listData1: [
        { code: 'bjrs', name: '毕节人社' },
        { code: 'bk', name: '本科' },
        { code: 'gz', name: '高职' },
        { code: 'zz', name: '中职' },
        { code: 'gj', name: '技师学院' },
        { code: 'jx', name: '技校' },
        { code: 'qy', name: '企业' },
      ],
      listData2: [],
      listData3: [],
      type: 'bjrs',
      queryform: {
        one: {
          name: '适用',
          code: '',
        },
        level: '',
        parentCode: {
          name: '专业大类',
          code: '',
        },
        three: {
          name: '专业类',
          code: '',
        },
      },
      typeList: [
        { code: '', name: '  全部' },
        { code: 'bjrs', name: '毕节人社' },
        { code: 'bk', name: '本科' },
        { code: 'gz', name: '高职' },
        { code: 'zz', name: '中职' },
        { code: 'gj', name: '技师学院' },
        { code: 'jx', name: '技校' },
        { code: 'qy', name: '企业' },
      ],
      //头部查询字段数据
    };
  },

  created() {
    //更新状态字典
    this.$dic.getStatusList(res => {
      this.statusListData = res;
      this.statusDict = res.reduce((pre, next) => {
        pre[next.index] = next.name;
        return pre;
      }, {});
    });

    this.refreshResourceList();
  },
  mounted() {
    // this.$EvenBus.$off('handleReject')
    let that = this;
    this.$EventBus.$on('handleReject', function (data) {
      if (!data) return;
      if (data.type == 'shenpiSure') {
        that.handleAgree(data);
      } else if (data.type == 'shenpiNo') {
        that.handleReject(data);
      }
    });
    this.setFilter();
  },
  watch: {
    optionsValue(val) {
      if (this.$refs.coursefilterWrap && val.length == 3) {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }
      if (this.$refs.coursefilterWrap && val.length == 2 && val[1] == 'all') {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }

      if (this.$refs.coursefilterWrap && val.length == 1 && val[0] == 'all') {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }
    },
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    onClick(data) {
      this.optionsValue = data.path;
      this.refreshResourceList();
      this.mouseenter(data);
      this.setFilter(data);
    },

    mouseenter(data) {
      let str = '';
      if (data && data.pathLabels) {
        if (data.pathLabels.length == 1) {
          str = data.pathLabels[0];
          this.tooltipValue = str;
        } else if (data.pathLabels.length == 2) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1];
          this.tooltipValue = str;
        } else if (data.pathLabels.length == 3) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1] + '/' + data.pathLabels[2];
          this.tooltipValue = str;
        }
        this.tooltipVisible = true;
      } else {
        this.tooltipValue = '全部';
      }
    },

    mouseDown() {
      this.tooltipVisible = false;
    },
    setFilter(data) {
      if (!data) {
        let getNode = document.querySelector('.el-cascader .el-input__inner');
        getNode.style.width = 80 + 'px';
        return;
      }
      let getNode = document.querySelector('.el-cascader .el-input__inner');
      let str = '';
      if (data.pathLabels && data.pathLabels.length > 0) {
        data.pathLabels.forEach(item => {
          str += item;
        });
      }

      if (str.length <= 5) {
        getNode.style.width = (str.length + 3) * 18 + 'px';
        return;
      }
      if (str.length > 17) {
        getNode.style.width = str.length * 18 + 'px';
        return;
      }
      getNode.style.width = (str.length + 2) * 18 + 'px';
    },

    onchange(data) {
      this.refreshResourceList();
    },
    resetquery() {
      this.queryform.parentCode = {
        name: '专业大类',
        code: '',
      };
      this.queryform.three = {
        name: '专业类',
        code: '',
      };
      this.listData2 = [];
      this.listData3 = [];
    },
    chooseType(item) {
      this.queryform.one = item;
      this.resetquery();
      this.pagination.page = 1;
      this.refreshResourceList();
      if (item.code == '') {
        return;
      }

      let params = {
        cate_type: this.queryform.one.code || '',
        level: '1',
        parentCode: '',
      };
      categoryList(params).then(res => {
        if (res.data) {
          this.listData2 = res.data;
        }
      });
    },
    chooseTypeTwo(item) {
      this.queryform.parentCode = item;
      this.queryform.three = {
        name: '专业类',
        code: '',
      };
      this.listData3 = [];
      this.pagination.page = 1;
      this.refreshResourceList();
      let params = {
        cate_type: this.queryform.one.code || '',
        level: '2',
        parentCode: this.queryform.parentCode.code,
      };

      categoryList(params).then(res => {
        if (res.data) {
          this.listData3 = res.data;
        }
      });
    },
    chooseTypeThree(item) {
      this.queryform.three = item;
      console.log(this.queryform.three);
      this.pagination.page = 1;
      this.refreshResourceList();
    },

    closeViewDialog() {
      this.viewDialogVisible = false;
    },
    product(item) {
      if (item.status == 8) {
        return '待审批';
      }
    },

    /**
     * 审核按钮
     */
    openAudit(item) {
      this.viewDialogVisible = true;
      this.currentItem = item;
      this.viewDialogData = item;
    },
    /**
     * 时间格式化
     */
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    /**
     * 清除筛选
     */
    clearFilter() {
      this.search = '';
      this.queryParams.forEach(item => {
        item.value = 0;
        item.code = '';
      });
      this.refreshResourceList();
    },
    /**
     * 查询列表
     */
    refreshResourceList() {
      this.loading = true;
      const tempData1 = {
        label: this.search,
        status: '8', //审批需求
        refer: this.optionsValue[0] == '' ? 'all' : this.optionsValue[0] || '',
        majorGroup: this.optionsValue[1] == 'all' ? '' : this.optionsValue[1] || '',
        majorGroup2: this.optionsValue[2] == 'all' ? '' : this.optionsValue[2] || '',
        currentPage: this.pagination.page,
        perPage: this.pagination.itemsPerPage,
      };
      list_model_resourceNew(tempData1).then(res => {
        this.list = res.data.items;
        this.pagination.total = res.data.total;
        this.loading = false;
      });
    },
    /**
     * 通过/驳回事件处理
     */
    handleAction(e) {
      this.showNewDialog = false;
      this.currentItem.apply_list.push({
        status: this.currentItem.status,
        remark: e.option,
        rejection: e.rejection,
        operator: this.currentItem.updater,
      });

      updateNewModelResource(this.currentItem).then(res => {
        if (res.code === '200') {
          this.$refs.view.btnLoading = false;
          this.$notify({
            timeout: 1500,
            message: '操作成功！',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          this.refreshResourceList();
          this.viewDialogVisible = false;
        } else {
          this.$notify({
            timeout: 1500,
            message: '操作失败',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'warning',
          });
        }
      });
    },
    /**
     * 通过
     */
    handleAgree(e) {
      if (this.currentItem.status === 8) this.currentItem.status = 9;
      this.handleAction(e);
    },
    /**
     * 驳回
     */
    handleReject(e) {
      if (this.currentItem.status === 8) this.currentItem.status = 10;
      this.handleAction(e);
    },
    /**
     * 关闭弹出框
     */
    handleCancel() {
      this.showNewDialog = false;
    },
    /**
     * 搜索框点击enter事件
     */
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.pagination.page = 1;
        this.refreshResourceList();
      }
    },
  },
  destroyed() {
    this.$EventBus.$off('handleReject');
  },
};
</script>
<style scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.header_wrapper {
  width: 100%;
  padding: 15px;
}

.model_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  width: 100%;
  height: 60px;
  border-radius: 7px;
  background: linear-gradient(60deg, #66bb6a, #43a047);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
}

.img_wrapper {
  width: 64px;
  height: 64px;
}

.img_wrapper img {
  width: 100%;
  height: 100%;
}
.v-List-actived {
  background: #ddd;
}
.disable-color {
  color: #ddd !important;
}

.disable-color i {
  color: #ddd !important;
}
.textWrap {
  position: relative;
}
.table {
  min-height: 610px;
}

#coursefilterWrap {
  margin-top: 7px;
  margin-left: 10px;
  /* width: 320px; */
}

#coursefilterWrap >>> .el-input:hover {
  /* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12); */
  box-shadow: 0 0 6px 1px #70707052;
  border-radius: 4px;
}
#coursefilterWrap >>> .el-input .el-input__inner {
  border: none;
  background: #4caf50 !important;
  color: #fff;
  font-weight: 700;
}
#coursefilterWrap >>> .el-input .el-input__inner::placeholder {
  color: #fff;
}
#coursefilterWrap >>> .el-input .el-input__suffix {
  color: #fff;
}

.el-cascader-menu {
  max-width: 250px;
}
.header {
  background: #4caf50 !important;
  height: 64px;
  overflow: hidden;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
</style>
